import { render } from "./AvaliacaoDeRiscoLista.vue?vue&type=template&id=7fefc92e&scoped=true"
import script from "./AvaliacaoDeRiscoLista.vue?vue&type=script&lang=js"
export * from "./AvaliacaoDeRiscoLista.vue?vue&type=script&lang=js"

import "./AvaliacaoDeRiscoLista.vue?vue&type=style&index=0&id=7fefc92e&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fefc92e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTooltip,QBtn,QRadio,QInput,QBadge,QCard,QCardSection,QField});
